import { render } from "./platformReceipt.vue?vue&type=template&id=1bdf1e1f&scoped=true"
import script from "./platformReceipt.vue?vue&type=script&lang=js"
export * from "./platformReceipt.vue?vue&type=script&lang=js"

import "./platformReceipt.vue?vue&type=style&index=0&id=1bdf1e1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdf1e1f"]])

export default __exports__